import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/providers/freee/partners`

const tenantProviderFreeePartner = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit}, { page, condition }) {
      const params = {
        page: page,
        ...condition
      }
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, params).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
}
export default tenantProviderFreeePartner
